import axios from 'axios'

import type { AxiosInstance, RawAxiosRequestHeaders } from 'axios'

type RestClientConfig = {
  baseURL: string
  headers?: RawAxiosRequestHeaders
}

export const createRestClient = ({ baseURL, headers }: RestClientConfig): AxiosInstance =>
  axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  })
